module.exports = "https://www.gc-pro.gnp.com.mx/76d9f61ae87a98bb27eabdcd073e5bd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/consultar-polizas/4.png
// module id = 1020
// module chunks = 0 1